/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";
import { EuiFlexGroup, EuiFlexItem, useEuiFontSize } from "@inscopix/ideas-eui";
import { memo } from "react";
import { TASK_TABLE_DETAIL_RENDERER_HEIGHT } from "./TasksTable";
import { TasksTableDetailRendererParamsGrid } from "./TasksTableDetailRendererParamsGrid";

const PADDING = 12;
const MARGIN = 10;

export interface TasksTableDetailRendererProps {
  tableId: string;
  rowId: string;
}
export const TasksTableDetailRenderer = memo(function TasksTableDetailRenderer(
  props: TasksTableDetailRendererProps,
) {
  const { fontSize } = useEuiFontSize("l");

  return (
    <div
      css={css`
        padding: ${PADDING}px;
      `}
    >
      <EuiFlexGroup
        css={css`
          height: 100%;
        `}
        gutterSize="none"
      >
        <EuiFlexItem
          css={css`
            margin-top: ${MARGIN}px;
          `}
        >
          <div
            css={css`
              height: calc(
                ${TASK_TABLE_DETAIL_RENDERER_HEIGHT - 2 * PADDING - MARGIN}px -
                  ${fontSize}
              );
            `}
          >
            <TasksTableDetailRendererParamsGrid
              tableId={props.tableId}
              rowId={props.rowId}
            />
          </div>
        </EuiFlexItem>
      </EuiFlexGroup>
    </div>
  );
});
